import { render } from "./NewOrder.vue?vue&type=template&id=31867ffc&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=ts"
export * from "./NewOrder.vue?vue&type=script&lang=ts"

import "./NewOrder.vue?vue&type=style&index=0&id=31867ffc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31867ffc"

export default script